export const apoEStatusOptions =
  'Select an Apo-E status, A4 homozygous, A4 heterozygous, Non-carrier, Not yet determined'.split(',');
